import {
   PractitionerReceptionServiceMarkAsRemovedCommand,
   ReceptionServiceWithPractitionersSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../translations';

type PractitionerReceptionServiceRemoveActionRenderProps = {
   removePractitioner: () => Promise<void>;
};

type PractitionerReceptionServiceRemoveActionProps = {
   readonly id: number;
   readonly children: (renderProps: PractitionerReceptionServiceRemoveActionRenderProps) => JSX.Element;
};

export const PractitionerReceptionServiceRemoveAction = (
   props: PractitionerReceptionServiceRemoveActionProps
): JSX.Element => {
   const { executeAsync: removePractitioner } = useCqrsCommand<void, void>(
      () => {
         const command = new PractitionerReceptionServiceMarkAsRemovedCommand();
         command.id = props.id;
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(ReceptionServiceWithPractitionersSimpleQuery);
            dispatchSnackbarPositiveEvent(
               receptionServiceTranslationKeys.table.remove.practitioner.confirmation.snackbar
            );
         },
      }
   );

   return (
      <>
         {props.children({
            removePractitioner: removePractitioner,
         })}
      </>
   );
};
